// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.AllRequiredDocuments = {
  exempReference: [],
  exemptReferenceFetched: false,
  exemptReferenceFrontloadRequest: false,
  workExperienceDataFetched: false,
};
